module.exports = __webpack_public_path__ + "img/token-presale.9f89f90b.svg";